var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('QS-h4-title',{attrs:{"title":"关联订单信息"}})],1),_vm._v(" "),_c('form-text-box',{attrs:{"column":2,"dataList":_vm.m_relationOrderInfo,"model":_vm.m_relationOrderInfoModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }